import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Award, CheckCircle } from "lucide-react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import SectionHeader from "../components/common/sectionHeader";
import Socials from "../components/about/socials";
import EngineeringIdentity from "../components/homepage/engineeringIdentity";
import ExperienceTimeline from "../components/homepage/experienceTimeline";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about") || SEO[1];

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.name}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta name="keywords" content={currentSEO.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />

				<main className="content-wrapper">
					<div className="about-container">
						<SectionHeader
							tag="About Soumik Saha"
							title="Building Engineering Depth in"
							highlight="Backend & Full-Stack Systems"
							subtitle="Software Engineer at TCS with 1+ year of professional experience building enterprise applications."
						/>

						<div className="about-hero-grid">
							<div className="about-bio-card">
								<p>
									I am a <strong>Software Engineer</strong> located in <strong>Kolkata, India</strong>, currently working at <strong>TCS (Tata Consultancy Services)</strong> on an enterprise HR and recruitment platform supporting over <strong>500,000 users</strong>.
								</p>
								<p>
									My primary strength is backend engineering using <strong>Java, Spring Boot, REST APIs, and PostgreSQL</strong>. I specialize in designing transactional services, implementing secure authentication (2FA/OTP), and optimizing database queries (~25–30% API latency reduction in enterprise modules).
								</p>
								<p>
									Beyond my day-to-day enterprise responsibilities, I actively construct independent full-stack products—such as <strong>SkyFleet</strong> (flight management and booking platform) and <strong>PulseConnect</strong> (real-time communication app)—to master distributed systems patterns and modern web architectures.
								</p>
							</div>

							<div>
								<Socials />
							</div>
						</div>

						<div className="achievements-card">
							<div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
								<Award size={20} color="#06b6d4" />
								<h3 style={{ margin: 0, fontSize: "1.25rem", color: "var(--primary-color)" }}>
									Recognitions & Achievements
								</h3>
							</div>
							<div>
								{INFO.achievements.map((item, idx) => (
									<div key={idx} className="achievement-item">
										<CheckCircle size={16} color="#10b981" style={{ flexShrink: 0, marginTop: "2px" }} />
										<span>{item}</span>
									</div>
								))}
							</div>
						</div>

						<EngineeringIdentity />

						<ExperienceTimeline />
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</main>
			</div>
		</React.Fragment>
	);
};

export default About;
